import React from 'react';
import { Container, Typography, Button, Box, useTheme } from '@mui/material';

const CTASection = () => {
  const theme = useTheme();

  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 8, md: 10 },
        background: theme.palette.gradient.main,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative Background Elements */}
      <Box
        sx={{
          position: 'absolute',
          top: -100,
          right: -100,
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.1)',
          filter: 'blur(80px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -150,
          left: -150,
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.05)',
          filter: 'blur(100px)',
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center' }}>
          {/* Heading */}
          <Typography
            variant="h2"
            sx={{
              color: 'white',
              mb: 2,
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '3rem' },
            }}
          >
            Start Monitoring Smarter Today
          </Typography>

          {/* Subheading */}
          <Typography
            variant="h6"
            sx={{
              color: 'rgba(255, 255, 255, 0.9)',
              mb: 4,
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.6,
              fontWeight: 400,
            }}
          >
            Join 500+ businesses optimizing their workforce with real-time insights
          </Typography>

          {/* CTA Button */}
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: 'white',
              color: 'primary.main',
              px: 5,
              py: 2,
              fontSize: '1.125rem',
              fontWeight: 700,
              borderRadius: '24px',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                transform: 'scale(1.05) translateY(-2px)',
                boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2)',
              },
            }}
          >
            Request Demo
          </Button>

          {/* Small Print */}
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              mt: 3,
              color: 'rgba(255, 255, 255, 0.8)',
              fontSize: '0.875rem',
            }}
          >
            No credit card required • Free 14-day trial
          </Typography>

          {/* Additional Trust Elements */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 3,
              mt: 4,
              flexWrap: 'wrap',
            }}
          >
            {[
              'Setup in 5 minutes',
              'Cancel anytime',
              '24/7 Support',
            ].map((text, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontWeight: 500,
                  }}
                >
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CTASection;
